import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from 'src/features/auth/contexts/AuthContext';

export function useLinkAccount() {
  const queryClient = useQueryClient();
  const { apiFetch } = useAuth();

  const linkAccount = useMutation({
    mutationFn: async (email: string) => {
      const res = await apiFetch('/api/v2/account/link-account', {
        method: 'POST',
        body: JSON.stringify({
          email,
        }),
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(JSON.stringify(data));
      }
      return data;
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: ['user'] });
      await queryClient.refetchQueries({ queryKey: ['link-account-check'] });
      await queryClient.refetchQueries({ queryKey: ['primary-user'] });
    },
  });

  return { linkAccount };
}
